import { IReportServiceMock } from "@/services";

export const mockReportService = (): IReportServiceMock => ({
  getReportsPage: jest.fn(),
  downloadReport: jest.fn(),
  deleteReport: jest.fn(),
});
